import { render } from "./Chatbots.vue?vue&type=template&id=74417f3e"
import script from "./Chatbots.vue?vue&type=script&lang=js"
export * from "./Chatbots.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__